<div class="left-side-menu">
    <div class="h-100" data-simplebar>

        <!-- User box -->
        <div class="user-box text-center">
            <!-- <img src="assets/images/users/user-1.jpg" alt="user-img" title="Mat Helme"
                class="rounded-circle avatar-md"> -->
            <div class="dropdown">
                <a href="javascript: void(0);" class="text-dark dropdown-toggle h5 mt-2 mb-1 d-block"
                    data-bs-toggle="dropdown">Geneva Kennedy</a>
                <div class="dropdown-menu user-pro-dropdown">

                    <!-- item-->
                    <a href="javascript:void(0);" class="dropdown-item notify-item">
                        <i class="fe-user me-1"></i>
                        <span>My Account</span>
                    </a>

                    <!-- item-->
                    <a href="javascript:void(0);" class="dropdown-item notify-item">
                        <i class="fe-settings me-1"></i>
                        <span>Settings</span>
                    </a>

                    <!-- item-->
                    <a href="javascript:void(0);" class="dropdown-item notify-item">
                        <i class="fe-lock me-1"></i>
                        <span>Lock Screen</span>
                    </a>

                    <!-- item-->
                    <a href="javascript:void(0);" class="dropdown-item notify-item">
                        <i class="fe-log-out me-1"></i>
                        <span>Logout</span>
                    </a>

                </div>
            </div>
            <p class="text-muted">Admin Head</p>
        </div>

        <!--- Sidemenu -->
        <div id="sidebar-menu">

            <ul id="side-menu">
    
                <li *ngFor="let mn of menu;let i=index;trackBy:trackByIndex">
                    <a href="#collapse{{i}}" data-bs-toggle="collapse">
                        <span>  {{mn.name}} </span>
                        <span class="menu-arrow"></span>
                    </a>

                    <div class="collapse" id="collapse{{i}}" *ngIf="mn.id != 7 && mn.id != 4339">
                        <ul class="nav-second-level">
                            <li *ngFor="let smn of mn.child;let j=index;trackBy:trackByIndex">
                                <a href="#collapse{{i}}{{j}}" data-bs-toggle="collapse">
                                    {{smn.name}} <span class="menu-arrow"></span>
                                </a>
                                <div class="collapse" id="collapse{{i}}{{j}}">
                                    <ul class="nav-second-level">
                                        <li *ngFor="let item of smn.data;let j=index;trackBy:trackByIndex">
                                            <a href="javascript: void(0);" class="menu-link-redi" [routerLink]="_common.getToken() ? ['/event/detail',item.event_id] : ['/guest/event/detail',item.event_id]">{{item.name}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="collapse" id="collapse{{i}}" *ngIf="mn.id == 7 || mn.id == 4339">
                        <ul class="nav-second-level" >
                            <li *ngFor="let item of mn.data;let j=index;trackBy:trackByIndex">
                                <a href="javascript:void(0);" class="menu-link-redi" [routerLink]="_common.getToken() ? ['/event/detail',item.event_id, item?.market_id] : ['/guest/event/detail',item.event_id, item?.market_id]">
                                    <i class="fa fa-circle"></i>
                                    <span>{{item?.event_name}}</span>
                                </a>
                            </li>
                        </ul>
                        </div>
                </li>
            </ul>

        </div>
        <!-- End Sidebar -->

        <div class="clearfix"></div>
    </div>
</div>